export const KEYS = {
  WINEBOX: 'winebox',
  CART: 'cart',
  STORE_ID: 'storeId',
  STORE_CONF: 'storeConf',
  CONFIGURATION_ID: 'configurationID',
  PERSON: 'person',
  PRIMEUR_USER: 'primeurUser',
  HASH_USER: 'hashUser',
  LANGUAGE: 'i18nextLng',
  ADMIN_TOASTS: 'adminToasts',
  SETTINGS: 'settings',
  FULLBOX: 'fullbox'
};

export const ERP_BOOLEAN = {
  TRUE: '1',
  FALSE: '2'
};
